import { mapGetters, mapActions } from 'vuex'
import VueJsonPretty from 'vue-json-pretty'

export default {
  components: {
    VueJsonPretty
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      isLoading: false,
      dialog: false,
      stackTraceJson: {}
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedProviderByCallManager'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true

    this.getStackTraceJson()
  },
  methods: {
    ...mapActions([
      'actionGetStackTraceJson'
    ]),
    capitalize (val) {
      return val[0].toUpperCase() + val.slice(1)
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    formatTitleModal (value) {
      let result = null

      if (value) {
        result = this.capitalize(value.split('-').join(' '))
      }

      return result
    },
    getStackTraceJson () {
      if (Object.keys(this.getterSelectedProviderByCallManager).length > 0 && this.getterSelectedProviderByCallManager.url) {
        this.isLoading = true

        this.actionGetStackTraceJson(this.getterSelectedProviderByCallManager.url)
          .then((response) => {
            this.isLoading = false

            if (response && response.data) {
              this.stackTraceJson = response.data
            } else {
              this.sendToast({
                text: 'O retorno não foi encontrado!',
                type: 'warning'
              })
            }
          })
          .catch(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Ocorreu um erro ao buscar os dados, tente novamente mais tarde.',
              type: 'danger'
            })
          })
      } else {
        this.sendToast({
          text: 'Não foi possível fazer a busca, a URL do serviço não foi encontrada!',
          type: 'warning'
        })
      }
    }
  }
}
